import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { PromoViewed } from '@app/+landing-cms/actions';

/**
 * When a promotion is displayed (Enhanced e-commerce) in the homepage body.
 */
const events = getEvents((action: PromoViewed) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: { ...action.payload }
  }
]);

export default events;
